// Lightweight, privacy-conscious GA4 (gtag.js) — env-driven, no-ops until a Measurement ID is set.

const measurementId = (process.env.REACT_APP_GA4_MEASUREMENT_ID || "").trim();
let initialized = false;

export const isAnalyticsConfigured = Boolean(measurementId);

export function initAnalytics() {
  if (!measurementId || initialized || typeof window === "undefined") return;

  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`;
  script.dataset.ga4 = "true";
  document.head.appendChild(script);

  window.gtag("js", new Date());
  window.gtag("config", measurementId, {
    send_page_view: false,            // we send page_view manually on route change
    anonymize_ip: true,               // explicit privacy signal
    allow_google_signals: false,      // no ad personalization / cross-device signals
    allow_ad_personalization_signals: false,
  });

  initialized = true;
}

export function trackPageView(url, title) {
  if (!initialized || !window.gtag) return;
  window.gtag("event", "page_view", {
    page_title: title || document.title,
    page_location: url || window.location.href,
    page_path: `${window.location.pathname}${window.location.search}`,
  });
}

export function trackAffiliateClick({ url, partner, placement } = {}) {
  if (!initialized || !window.gtag) return;
  let hostname = "";
  try { hostname = new URL(url, window.location.origin).hostname; } catch (e) { /* ignore */ }
  window.gtag("event", "affiliate_link_click", {
    link_domain: hostname,
    partner: partner || "unknown",
    placement: placement || "unknown",
  });
}
